import { useMemo } from 'react';
import produce from 'immer';
import { useQuery } from 'data-fetching-client';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import { PAYMENT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { GET_ACCESS_BY_OBJECT_TYPE_ID, GET_PAYMENT_ELIGIBILITY } from 'automation-ui-enrollment/queries/AccessQueries';
const EMPTY_ACCESS_RESPONSE = {};
export default function useAccessByObjectTypeId({
  flowSourceApp = WORKFLOWS_APP
} = {}) {
  var _accessData$enrollmen;
  const {
    data: accessData,
    loading,
    error
  } = useQuery(GET_ACCESS_BY_OBJECT_TYPE_ID, {
    variables: {
      flowSourceApp
    }
  });
  const accessByObjectTypeId = (_accessData$enrollmen = accessData === null || accessData === void 0 ? void 0 : accessData.enrollment_accessByObjectTypeId) !== null && _accessData$enrollmen !== void 0 ? _accessData$enrollmen : EMPTY_ACCESS_RESPONSE;
  const {
    data: paymentEligibilityData
  } = useQuery(GET_PAYMENT_ELIGIBILITY);
  const data = useMemo(() => produce(accessByObjectTypeId, draftAccessByObjectTypeId => {
    const paymentAccess = draftAccessByObjectTypeId[PAYMENT_ID];
    if ((paymentAccess === null || paymentAccess === void 0 ? void 0 : paymentAccess.accessLevel) === 'NO_ACCESS' && (paymentEligibilityData === null || paymentEligibilityData === void 0 ? void 0 : paymentEligibilityData.paymentEligibility.status) === 'ELIGIBLE') {
      paymentAccess.accessLevel = 'UPGRADE_ACCESS';
    }
  }), [accessByObjectTypeId, paymentEligibilityData]);
  return {
    data,
    loading,
    error
  };
}